import React from "react";

const Logo = ({ className = "h-9 w-9" }) => (
  <div data-testid="brand-logo" className={`relative ${className}`}>
    <svg viewBox="0 0 64 64" className="w-full h-full">
      <defs>
        <linearGradient id="hrnGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FF6B00" />
          <stop offset="100%" stopColor="#FF8533" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#0B1320" stroke="url(#hrnGrad)" strokeWidth="2" />
      <path d="M16 46 L16 18 L22 18 L22 30 L32 30 L32 18 L38 18 L38 46 L32 46 L32 36 L22 36 L22 46 Z" fill="#F0F4F8" />
      <circle cx="48" cy="22" r="3" fill="#FF6B00" />
      <path d="M44 28 L52 28 L48 22 Z" fill="#FF6B00" opacity="0.4" />
    </svg>
  </div>
);

export default Logo;
